/* eslint-disable max-len */
import 'react';

const TipsReferenceListSvg = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g fill="#878D99" fillRule="nonzero">
            <path d="M6 0a6 6 0 110 12A6 6 0 016 0zm0 1a5 5 0 100 10A5 5 0 006 1z" />
            <path d="M6 4.5a.5.5 0 01.492.41L6.5 5v4a.5.5 0 01-.992.09L5.5 9V5a.5.5 0 01.5-.5zM6 2.705a.5.5 0 01.492.41l.008.09v.213a.5.5 0 01-.992.09l-.008-.09v-.213a.5.5 0 01.5-.5z" />
        </g>
    </svg>
);
export default TipsReferenceListSvg;
